/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { Container } from '@material-ui/core';
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import PlantsYouLove from '../GraphqlHomePage/Partials/Yotpo/PlantsYouLove';
import YotpoHPWidget from '../GraphqlHomePage/Partials/Yotpo/YotpoHPWidget';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = () => ({
    customerReviews: {
        '& h1': {
            textAlign: 'center',
            textTransform: 'uppercase',
            fontFamily: 'BebasNeue',
            marginBottom: '0',
            fontSize: '2.5rem',
            lineHeight: '38px',
            fontWeight: 500,
        },
        '& a': {
            fontWeight: 700,
        },
    },
});

const seo = {
    page_title: 'Plants.com Customer Reviews | Plants.com',
    meta_description: 'Read Plants.com reviews and see what people are loving about our plant gifts! Read testimonials and ratings from our Plants.com customers!',
    keywords: 'plants.com customer reviews',
};

const CustomerReviewsPlants = ({ classes }) => (
    <Container className={classes.customerReviews}>
        <GraphqlSeoHeadTags seoData={seo} />
        <h1>Plants.com Reviews</h1>
        <PlantsYouLove />
        <YotpoHPWidget isCustomerReviewPage />
    </Container>
);

CustomerReviewsPlants.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(CustomerReviewsPlants);
